import React, { useEffect, useReducer } from 'react';
import rpsReducer from "../../reducers/rps";
import * as action from "../../actions/rps";
import LineChart from "./LineChart";
import ScatterChart from "./ScatterChart";
import { LoadIndicator } from 'devextreme-react/load-indicator';
import moment from "moment";
const stateInit = {printInfo: null}
export default ({spsId, title }) => {
    const [state, dispatch] = useReducer(rpsReducer, stateInit);
    let { printInfo } = state;
    useEffect(() => {
        if (spsId)
            action.fetchPrintInfo(dispatch, spsId);
    }, [spsId])

    const getHtmData = d => {
        return <div
            dangerouslySetInnerHTML={{
                __html: `${d}`
            }}></div>
    }
    const Box1 = () => {
        let { kpiunits, currentGoal, currentState, areaToSolve } = printInfo
        return <div className="items" >
            <h2 >Box 1 - &nbsp;Reason for Action</h2>
            <div><label>KPI Unit: </label><span className="print-val">{kpiunits}</span></div>
            <div><label>Current Goal: </label><span className="print-val">{currentGoal}</span></div>
            <div><label>Current State: </label><span className="print-val">{currentState}</span></div>
            <div><label>Problem Statement: </label><span className="print-val">{[currentGoal - currentState] + ' ' + kpiunits + ' Gap ON ' + areaToSolve}</span></div>
        </div>
    }
    const Box9 = () => {
        let { whatWentWell, whatNotWentWell, whatHindered, whatHelped, leasonLearnt } = printInfo
        return <div className="items bx9" >
            <h2 >Box 9 - &nbsp; Insights & Actions</h2>
            <div><label>What went well?: </label><span className="print-val">{whatWentWell}</span></div>
            <div><label>What didnt go well?: </label><span className="print-val">{whatNotWentWell}</span></div>
            <div><label>What helped?: </label><span className="print-val">{whatHelped}</span></div>
            <div><label>What hindered?: </label><span className="print-val">{whatHindered}</span></div>
            <div><label>Where can lessons learnt be applied?: </label><span className="print-val">{leasonLearnt? leasonLearnt.substring(0, 500): '' }</span></div>
        </div>
    }
    const Box2 = () => {
        let { isContainment, containment, initialState } = printInfo
        return <div className="items" >
            <h2 >Box 2 - &nbsp;Breakdown the Problem</h2>
            <div><label>Establish point of cause: </label><span className="print-val">{initialState}</span></div>
            <div><label>Do we need containment?: </label><span className="print-val">{isContainment? 'Yes': 'No'}</span></div>
            {isContainment && <div><span className="print-val">{containment}</span></div>}
        </div>
    }
    
    const Box3 = () => {
        let { tsdoWhat, tshowMuch, tstoWhat, tsbyWhen } = printInfo
        return <div className="items" >
            <h2 >Box 3 - &nbsp;Target State</h2>
            <div><label>Do What: </label><span className="print-val">{tsdoWhat}</span></div>
            <div><label>To What: </label><span className="print-val">{tstoWhat}</span></div>
            <div><label>How Much: </label><span className="print-val">{tshowMuch}</span></div>
            <div><label>By When: </label><span className="print-val">{tsbyWhen}</span></div>
            <div><label>Target Statement: </label><span className="print-val">{`${tsdoWhat} on ${tstoWhat} by ${tshowMuch}, by ${tsbyWhen}`}</span></div>
        </div>
    }
    
    const Box4 = () => {
        let {  rootCauseAnalysisEditor, lsRCA } = printInfo
        return <div className="items" >
            <h2 >Box 4 - &nbsp;Root Cause Analysis</h2>
            <div>
                <table class="print-sps-tbl">
                    <thead>
                        <tr>
                            <th>Cause#</th>
                            <th>Root Cause(s)(Description)</th>
                        </tr>
                    </thead>
                    {lsRCA && lsRCA.length > 0 &&
                        <tbody>{
                            lsRCA.map((d, i) => <tr key={i}>
                                <td>{d.causeId}</td>
                                <td>{d.cause}</td>
                            </tr>)
                        } 
                        </tbody>
                    }
                </table>
            </div>
        </div>
    }

    const Box5 = () => {
        let { lsRCASolution } = printInfo
        return <div className="items">
            <h2 >Box 5 - &nbsp;Solution Approach</h2>
            <div>
                <table class="print-sps-tbl">
                    <thead>
                        <tr>
                            <th>Cause#</th>
                            <th>Solution</th>
                            <th>Solution ID</th>
                            <th>Expected Improvement</th>
                            <th>PICK Status</th>
                        </tr>
                    </thead>
                    {lsRCASolution && lsRCASolution.length > 0 &&
                        <tbody>{
                            lsRCASolution.map((d, i) => <tr key={i}>
                                <td>{d.causeID}</td>
                                <td>{d.solution}</td>
                                <td>{d.solutionId}</td>
                                <td>{d.expectedImprovement}</td>
                                <td>{d.pickStatus}</td>
                            </tr>)
                        }
                        </tbody>
                    }
                </table>
            </div>
            {lsRCASolution && lsRCASolution.length > 0 &&
                <div className="soln_chart">
                    <ScatterChart solutionData={lsRCASolution} chartId="print_sa_chart" isPrint={true} />
                </div>
            }
        </div>
    }

    const Box6 = () => {
        let { lsExperiment, isExperiments } = printInfo
        return <div className="items" >
            <h2 >Box 6 - &nbsp;Rapid Experiment</h2>
            <div><label>Not applicable: </label><span className="print-val">{isExperiments ? 'Yes' : 'No'}</span></div>
            <div>
                <table class="print-sps-tbl">
                    <thead>
                        <tr>
                            <th>Experiment Description</th>
                            <th>Expected Results</th>
                            <th>Due Date</th>
                            <th>Actual Results</th>
                        </tr>
                    </thead>
                    {lsExperiment && lsExperiment.length > 0 &&
                        <tbody>{
                            lsExperiment.map((d, i) => <tr key={i}>
                                <td>{d.description}</td>
                                <td>{d.expectedResults}</td>
                                <td>{d.dueDate}</td>
                                <td>{d.actualResults}</td>
                            </tr>)
                        }
                        </tbody>
                    }
                </table>
            </div>
        </div>
    }

    const printDate = () => moment().format("MM/DD/YYYY")

    const Box7 = () => {
        let { lsCompletionPlan } = printInfo
        return <div className="items lt">
            <h2 >Box 7 - &nbsp;Completion Plan</h2>
            <div>
                <table class="print-sps-tbl">
                    <thead>
                        <tr>
                            <th>Task</th>
                            <th>Metric</th>
                            <th>Due Date</th>
                            <th>Owner</th>
                            <th>Completed Date</th>
                            <th>Status</th>
                            <th>Andon</th>
                        </tr>
                    </thead>
                    {lsCompletionPlan && lsCompletionPlan.length > 0 &&
                        <tbody>{
                            lsCompletionPlan.map((d, i) => <tr key={i}>
                                <td>{d.task}</td>
                                <td>{d.metric}</td>
                                <td>{d.dueDate}</td>
                                <td>{d.owner}</td>
                                <td>{d.completedOn}</td>
                                <td>{d.status}</td>

                                <td><span className="addon" style={{ background: d.andon }}> </span></td>
                            </tr>)
                        }
                        </tbody>
                    }
                </table>
            </div>
        </div>
    }

    const Box8 = () => {
        let { lsResult, resultFrequency, resultTimePeriod, resultsStartDate, kpiunits } = printInfo
        return <div className="items lt" >
            <h2 >Box 8 - &nbsp;Confirmed Results</h2>
            <div className="ds-flx cr-info"><div><label>KPI: </label><span className="print-val">{kpiunits}</span></div>
                <div><label>Start Date: </label><span className="print-val">{resultsStartDate}</span></div>
                <div><label>Time Period (days): </label><span className="print-val">{resultTimePeriod}</span></div>
                <div><label>Reporting Frequency: </label><span className="print-val">{resultFrequency}</span></div>
            </div>
            <div className="ds-flx"><div style={{ width: '40%' }}>
                <table class="print-sps-tbl">
                    <thead>
                        <tr>
                            <th style={{ width: '70px' }}>Date</th>
                            <th style={{ width: '14px' }}>Target (%)</th>
                            <th style={{ width: '14px' }}>Actual (%)</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    {lsResult && lsResult.length > 0 &&
                        <tbody>{
                            lsResult.map((d, i) => <tr key={i}>
                                <td>{d.resultDate}</td>
                                <td>{d.target}</td>
                                <td>{d.actual}</td>
                                <td>{d.notes}</td>
                            </tr>)
                        }
                        </tbody>
                    }
                </table>
            </div>
                <div  style={{ width: '59%' }}>
                {lsResult && lsResult.length > 0 ? (
                    <LineChart
                        target="Target"
                        actual="Actual"
                        chartId="print_rslt"
                        chartData={lsResult}
                    />
                ) : null}
            </div>
            </div>
        </div>
    }

    const Page2 = () => {
        let { processOwner, coach, startDate, dueDate, areaToSolve, ptsVal, teamMembers, completedOn ,module,SubModule } = printInfo
        return <table className="back-page">
            <tbody>
                <tr>
                    <td>Process Owner</td>
                    <td>{processOwner}</td>
                </tr>
                <tr>
                    <td>Approver</td>
                    <td>{coach}</td>
                </tr>
                <tr>
                    <td>Start Date</td>
                    <td>{startDate}</td>
                </tr>
                <tr>
                    <td>Due Date</td>
                    <td>{dueDate}</td>
                </tr>
                <tr>
                    <td>Close Date</td>
                    <td>{completedOn ? completedOn: ''}</td>
                </tr>
                <tr>
                    <td>Area to Solve</td>
                    <td>{areaToSolve }</td>
                </tr>
                <tr>
                    <td>Problem to Solve</td>
                    <td>{ptsVal}</td>
                </tr>
                <tr>
                    <td>Module</td>
                    <td>{module}</td>
                </tr>
                <tr>
                    <td>Team Members</td>
                    <td>{teamMembers}</td>
                </tr>
            </tbody>
        </table>
    }


    return printInfo ? <><h3 className="print-head">Front Page</h3><div className="f-p-titl"><div className="print-title" style={{ width: '80%', textAlign: 'center' }}>{title}</div><div style={{ width: '20%', textAlign: 'right', paddingRight: '20px' }}>{printDate()}</div> </div><div className="box"><div style={{ width: '20%' }} className="items-flx"><Box1 /><Box2 /><Box3 /></div><div style={{ width: '32%' }} className="items-flx"><Box4 /><Box5 /><Box6 /></div><div style={{ width: '46%' }} className="items-flx"><Box7 /><Box8 /><Box9 /></div></div>
        <h3 className="print-head">Back Page</h3>
        <div className="f-p-titl" ><div className="print-title" style={{ width: '80%', textAlign: 'center', fontSize: '22px' }}>{title}</div><div style={{ width: '20%', textAlign: 'right', paddingRight: '20px' }}>{printDate()}</div> </div>
        <div className="b-box"> <div style={{ width: '80%', marginTop: "10%" }}><Page2 /></div></div></> : !spsId ? <h3>Print preview not available at the momemt. Please save the General details to view the Print Preview.</h3> : <LoadIndicator className="button-indicator" visible={true} />;

}